import React from 'react';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-dental-800 mb-8">About TeethKart</h1>
        
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-8">
          <div className="p-6">
            <h2 className="text-2xl font-semibold text-dental-800 mb-4">Our Story</h2>
            <p className="text-gray-600 mb-4">
              TeethKart was founded in 2022 with a simple mission: to make quality dental products accessible to dental professionals across India. What started as a small online store has grown into India's largest dental e-commerce platform, serving thousands of dentists, clinics, and hospitals nationwide.
            </p>
            <p className="text-gray-600">
              Our team consists of dental professionals, e-commerce experts, and customer service specialists who understand the unique needs of the dental industry. We work directly with manufacturers and authorized distributors to ensure that every product on our platform is genuine, high-quality, and competitively priced.
            </p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-8">
          <div className="p-6">
            <h2 className="text-2xl font-semibold text-dental-800 mb-4">Our Mission</h2>
            <p className="text-gray-600">
              At TeethKart, we're committed to revolutionizing the dental supply chain in India. Our mission is to provide dental professionals with a seamless online shopping experience, offering the widest range of dental products at competitive prices, with fast delivery and exceptional customer service.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="bg-primary-50 rounded-full p-4 inline-flex mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-dental-800 mb-2">Quality Assurance</h3>
                <p className="text-gray-600">
                  We guarantee the authenticity and quality of every product on our platform.
                </p>
              </div>
              
              <div className="text-center">
                <div className="bg-primary-50 rounded-full p-4 inline-flex mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-dental-800 mb-2">Fast Delivery</h3>
                <p className="text-gray-600">
                  We deliver across India with express shipping options for urgent requirements.
                </p>
              </div>
              
              <div className="text-center">
                <div className="bg-primary-50 rounded-full p-4 inline-flex mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-dental-800 mb-2">Expert Support</h3>
                <p className="text-gray-600">
                  Our customer service team includes dental professionals who understand your needs.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-8">
          <div className="p-6">
            <h2 className="text-2xl font-semibold text-dental-800 mb-4">Why Choose TeethKart?</h2>
            
            <div className="space-y-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-medium text-dental-800">Extensive Product Range</h3>
                  <p className="text-gray-600">
                    With over 2,000 products across all dental categories, we offer the widest selection of dental supplies in India.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-medium text-dental-800">Competitive Pricing</h3>
                  <p className="text-gray-600">
                    We negotiate directly with manufacturers to offer you the best prices, with additional discounts for bulk orders.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-medium text-dental-800">Secure Shopping</h3>
                  <p className="text-gray-600">
                    Our platform uses industry-standard security measures to protect your personal and payment information.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-medium text-dental-800">Hassle-Free Returns</h3>
                  <p className="text-gray-600">
                    We offer a 7-day return policy for most products, ensuring your complete satisfaction with every purchase.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
